import React from 'react';
// Import tipe yang benar dari react-hook-form
import { Control, FieldErrors, UseFormRegister } from 'react-hook-form';

// Import tipe form utama untuk pengetikan yang kuat
import { CreateBookingFormV4 } from '../../../../services/create-booking-v4/schema/CreateBookingSchemaV4';

// Asumsi komponen anak sudah ada versi V4-nya
import AgentSelectComponentV4 from '../AgentSelectComponent';
import CountrySelectOptionComponentV4 from '../create-reservation/CountrySelectOptionComponent';
import clsx from 'clsx';
import DateInput from '../../../../shared/components/form/DateInput';

// Definisikan tipe untuk props dengan benar
interface GuestDetailFormPropsV4 {
    register: UseFormRegister<CreateBookingFormV4>;
    control: Control<CreateBookingFormV4>;
    errors: FieldErrors<CreateBookingFormV4>;
}

const GuestDetailFormV4: React.FC<GuestDetailFormPropsV4> = ({ register, control, errors }) => {
    return (
        <>
            <div className="mb-4">
                <h5 className="fw-bold">Primary Contact for this Reservation</h5>
                <p className="text-muted small mb-0">
                    This information will be used for all communication regarding this group booking.
                    The guest name for each individual room can be specified in the 'Invoice & Rooms' tab.
                </p>
            </div>
            <div className="row mb-3 align-items-start">
                <div className="col-sm-4">
                    <label htmlFor="phone" className="col-form-label d-flex">Phone:</label>
                    <input
                        type="text"
                        className={clsx('form-control app-form-control rounded-1', { 'is-invalid': errors.customer_phone })}
                        placeholder="Phone"
                        {...register('customer_phone')}
                    />
                    {errors.customer_phone && <span className="text-danger small mt-1">{errors.customer_phone.message}</span>}
                </div>

                <div className="col-sm-4">
                    <label htmlFor="address" className="col-form-label d-flex">Address:</label>
                    <input
                        type="text"
                        className={clsx('form-control app-form-control rounded-1', { 'is-invalid': errors.customer_address })}
                        placeholder="Address"
                        {...register('customer_address')}
                    />
                    {errors.customer_address && <span className="text-danger small mt-1">{errors.customer_address.message}</span>}
                </div>

                {/* Komponen anak untuk memilih negara */}
                <CountrySelectOptionComponentV4 control={control} errors={errors} />
            </div>

            <div className="row mb-3 align-items-start">
                <div className="col-sm-3">
                    <label htmlFor="state" className="col-form-label d-flex">State:</label>
                    <input
                        type="text"
                        className={clsx('form-control app-form-control rounded-1', { 'is-invalid': errors.customer_state })}
                        placeholder="State"
                        {...register('customer_state')}
                    />
                    {errors.customer_state && <span className="text-danger small mt-1">{errors.customer_state.message}</span>}
                </div>
                <div className="col-sm-3">
                    <label htmlFor="city" className="col-form-label d-flex">City:</label>
                    <input
                        type="text"
                        className={clsx('form-control app-form-control rounded-1', { 'is-invalid': errors.customer_city })}
                        placeholder="City"
                        {...register('customer_city')}
                    />
                    {errors.customer_city && <span className="text-danger small mt-1">{errors.customer_city.message}</span>}
                </div>
                <div className="col-sm-3">
                    <label htmlFor="postal_code" className="col-form-label d-flex">Postal Code:</label>
                    <input
                        type="text"
                        className={clsx('form-control app-form-control rounded-1', { 'is-invalid': errors.customer_zip })}
                        placeholder="Postal Code"
                        {...register('customer_zip')}
                    />
                    {errors.customer_zip && <span className="text-danger small mt-1">{errors.customer_zip.message}</span>}
                </div>
                <div className="col-sm-3">
                    <label htmlFor="id_number" className="col-form-label d-flex">ID Number:</label>
                    <input
                        type="text"
                        className={clsx('form-control app-form-control rounded-1', { 'is-invalid': errors.customer_identity_number })}
                        placeholder="ID Number"
                        {...register('customer_identity_number')}
                    />
                    {errors.customer_identity_number && <span className="text-danger small mt-1">{errors.customer_identity_number.message}</span>}
                </div>
            </div>

            <div className="row mb-3 align-items-start">
                <div className="col-sm-4">
                    <AgentSelectComponentV4 control={control} errors={errors} />
                </div>
                <div className='col-sm-4'>
                    <label htmlFor="birthday" className="col-form-label d-flex">Birthday:</label>
                    <DateInput
                        isInvalid={!!errors.customer_date_of_birth}
                        {...register('customer_date_of_birth')}
                    />
                    {errors.customer_date_of_birth && <span className="text-danger small mt-1">{errors.customer_date_of_birth.message}</span>}
                </div>
            </div>
        </>
    );
};

export default GuestDetailFormV4;